export default __webpack_public_path__ + "static/media/GoodyearLeasingLogo_Yellow.b40f19e3.png";